<!-- <div class="container-fluid">
    <div class="row">
        <div class="col-md-3">
            <nav id="secondary-navigation" *ngIf="showSideMenu">
                <header class="header">
                    <h5>Eco Club</h5>
                </header>
                <ul>
                    <li routerLinkActive="active">
                        <a routerLink="/activities/eco-club/2025-2026" (click)="checkRoute()">2025-2026</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/activities/eco-club/2023-2024" (click)="checkRoute()">2023-2024</a>
                    </li>

                </ul>
            </nav>
        </div>
        <div [ngClass]="fullWidth ? 'col-md-12' : 'col-md-9'">
            <router-outlet></router-outlet>
        </div>
    </div>
</div> -->
<div id="vismad" class="container-fluid ">
    <div class="row">
        <div class="col-md-3">
            <nav id="secondary-navigation">
                <header class="header">
                    <h5>Eco Club</h5>
                </header>
                <ul>
                    <li class="first">
                        <a (click)="changeRoute('2025-26')">2025-26</a>
                    </li>
                    <li class="second">
                        <a (click)="changeRoute('2023-24')">2023-24</a>
                    </li>

                </ul>
            </nav>
        </div>
        <div class="col-md-9" *ngIf="showPdf">
            <div id="sports">
                <div class="container-fluid pdf">
                    <div class="row">
                        <div class="col-12">
                            <div class="card shadow-lg">
                                <div class="container-fluid d-flex justify-content-center align-items-center h-100"
                                    id="loader" *ngIf="isLoading">
                                    <app-loader></app-loader>
                                </div>
                                <div id="detail" class="text-center">
                                    <pdf-viewer [src]="src" [render-text]="true" style="display: block;" id="list-view"
                                        (on-progress)="hideLoader()" (error)="hideLoader()"></pdf-viewer>

                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-9" *ngIf="!showPdf">
            <div id="sports">
                <div class="container-fluid pdf">
                    <div class="row">
                        <div class="col-12">
                            <div class="card shadow-lg">
                                <div class="container-fluid d-flex justify-content-center align-items-center h-100"
                                    id="loader" *ngIf="isLoading">
                                    <app-loader></app-loader>
                                </div>
                                <div id="detail" class="text-center">
                                    <pdf-viewer [src]="src" [render-text]="true" style="display: block;" id="list-view"
                                        (on-progress)="hideLoader()" (error)="hideLoader()"></pdf-viewer>

                                </div>


                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>
</div>